import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["trigger", "section"];
	static values = {
		showWhen: String,
	};

	toggle(event) {
		this.updateVisibility(event.target.value);
	}

	connect() {
		const checkedTrigger = this.triggerTargets.find((trigger) => trigger.checked);
		if (checkedTrigger) {
			this.updateVisibility(checkedTrigger.value);
		}
	}

	updateVisibility(value) {
		this.sectionTargets.forEach((section) => {
			const showWhen = section.dataset.conditionalSectionShowWhen || this.showWhenValue;
			const shouldShow = value === showWhen;
			section.classList.toggle("hidden", !shouldShow);
			if (section.dataset.conditionalSectionDisableWhenHidden === "true") {
				section.querySelectorAll("input, select, textarea").forEach((field) => {
					field.disabled = !shouldShow;
				});
			}
		});
	}
}
